// hrllo

import { endpointsMd } from "utils/metadata-split/constant";

export const arr = ["hhh", "jjj"];

export type createDeliveryTypes = {
  test_id: string;
  label: string;
  start_date_time?: string | undefined;
  end_date_time?: string | undefined;
  is_jumble: string;
  attendance: string;
  academic_year_id: string;
  reservation_status_id: string;
  class_id: string;
  batch_id: string;
  sub_batch_id: string;
  state_object_id: string[];
  district_id: string;
  college_object_id: string;
  board_id: string;
  ntse_exam_object_id: any;
  naps_level_list: any;
  delivery_type_object_id: any;
  warm_up_delivery_id: any;
  show_hint: string;
  show_results: string;
  show_response_sheet: string;
  show_revise_now: string;
};

export const createDeliveryInitialValues: createDeliveryTypes = {
  test_id: "",
  label: "",
  // start_date_time: undefined,
  // end_date_time: undefined,
  is_jumble: "",
  attendance: "",
  academic_year_id: "",
  reservation_status_id: "",
  class_id: "",
  batch_id: "",
  sub_batch_id: "",
  state_object_id: [],
  district_id: "",
  college_object_id: "",
  board_id: "",
  ntse_exam_object_id: "",
  naps_level_list: "",
  delivery_type_object_id: "",
  warm_up_delivery_id: "",
  show_hint: "false",
  show_results: "true",
  show_response_sheet: "true",
  show_revise_now: "false",
};

export const deliveryListMetakey={
  state:"state_list_ex_sch",
  year:"academic_year_list_ex_sch",
  college:"college_list_ex_sch",
  batch:"batch_list_ex_sch",
  sub_batch:"sub_batch_list_ex_sch",
}

export const mandatoryFields = (testType: string) => {
  const basicFields = [
    { id: "test_id" },
    { id: "label" },
    { id: "class_id" },
    { id: "academic_year_id" },
    { id: "reservation_status_id" },
    { id: "batch_id" },
    { id: "sub_batch_id" },
  ];
  return testType === "Scheduled Tests"
    ? [
        ...basicFields,
        { id: "start_date_time" },
        { id: "end_date_time" },
        { id: "is_jumble" },
        { id: "attendance" },
        { id: "show_results" },
        { id: "show_response_sheet" },
        { id: "show_revise_now" },
      ]
    : basicFields;
};

export const dataHelper = [
  {
    delivery_id: "V8JkzCWThl",
    warm_up_delivery_id: null,
    schedule_exam_delivery_id: null,
    delivery_uri: "http://35.244.54.194/gcf.rdf#17567123021469051421",
    test_id: "r92xnAiQfa",
    label: "Final _Analysis2",
    test_name: "Final _Analysis",
    test_uri: "http://35.244.54.194/gcf.rdf#i17567117047852168",
    is_jumble: false,
    attendance: "No",
    created_date: "2025-09-01",
    start_date_time: "2025-09-01 13:10:00",
    end_date_time: "2025-09-30 18:30:00",
    created_user_name: "raveendrak@narayanagroup.com",
    show_results_and_revise_now: true,
    show_results: true,
    show_revise_now: true,
    show_response_sheet: true,
    exam_category_id: "z9VL25WPdd",
    exam_category_name: "Scheduled Tests",
    class_list: ["FTwES7l9aJ"],
    academic_year_list: ["KnnWTL81kg"],
    state_list: [],
    district_list: [],
    college_list: [],
    reservation_status_list: ["huSALB93yD", "oqAAgvhHll", "pChDSWggAp"],
    batch_list: ["Cq9J0b28D2"],
    sub_batch_list: ["HsfxpYUUS6"],
    board_list: [],
    cnaps_level_list: [],
    ntse_exam_object_id: "",
    delivery_type_object_id: "jEnJKAgdI8",
  },
];

export function filterByIds(data, ids, idKey) {
  if (!Array.isArray(data) || !Array.isArray(ids)) return [];

  return data.filter((item) => ids.includes(item[idKey]));
}

export const createDeliveryProperties = (testType) => {
  const path = window.location.pathname;
  const editDelivery = path.includes("edit") || path.includes("duplicate");
  const isDisabled =
    testType !== "Scheduled Tests" && editDelivery ? true : false;
  const isRequiered = testType === "Scheduled Tests" ? true : false;
  return [
    {
      id: "start_date_time",
      type: "date-time-picker",
      label: "Start Date",
      className: "name-styles",
      required: isRequiered,
      breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
      maxDateTime: "end_date_time",
      disabled: isDisabled,
    },
    {
      id: "end_date_time",
      type: "date-time-picker",
      label: "End Date",
      required: isRequiered,
      breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
      minDateTime: "start_date_time",
      disabled: isDisabled,
    },
    {
      id: "is_jumble",
      type: "normal-select",
      label: testType === "Scheduled Tests" ? "Is Jumbled *" : "Is Jumbled",
      className: "select-styles",
      list: "jumble_status",
      required: isRequiered,
      onlyApiCall: true,
        requestList: async (payload) => {
          return {};
        },
      endpoint:endpointsMd.GET_JUMBLE_STATUS_LIST,
      breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
      options: [],
      keyValue: { label: "jumble_status_name", value: "jumble_status_id" },
      //keyValue: { label: "name", value: "object_id" },
      disabled: isDisabled,
    },
    {
      id: "attendance",
      type: "normal-select",
      label: testType === "Scheduled Tests" ? "Attendance *" : "Attendance",
      list: "attendance_status",
      className: "select-styles",
      required: isRequiered,
      breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
      options: [],
      onlyApiCall: true,
        requestList: async (payload) => {
          return {};
        },
      endpoint:endpointsMd.GET_ATTENDANCE_STATUS_LIST,
      keyValue: { label: "attendance_status_name", value: "attendance_status_id" },
      //keyValue: { label: "name", value: "object_id" },
      disabled: isDisabled,
    },
    {
      id: "show_hint",
      type: "normal-select",
      label: "Show Hint",
      className: "select-styles",
      breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
      options: [
        { label: "True", value: "true" },
        { label: "False", value: "false" },
      ],
      hideNone:true
    },
    {
      id: "show_results",
      type: "normal-select",
      label: "Show Result",
      className: "select-styles",
      breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
      options: [
        { label: "True", value: "true" },
        { label: "False", value: "false" },
      ],
      hideNone:true
    },
    {
      id: "show_response_sheet",
      type: "normal-select",
      label: "Show Response Sheet",
      className: "select-styles",
      breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
      options: [
        { label: "True", value: "true" },
        { label: "False", value: "false" },
      ],
      hideNone:true
    },
    {
      id: "show_revise_now",
      type: "normal-select",
      label: "Show Revise now",
      className: "select-styles",
      breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
      options: [
        { label: "True", value: "true" },
        { label: "False", value: "false" },
      ],
      hideNone:true,
      disabled:true
    },
  ];
};


export const createBuildTestProperties = [
  {
    id: "academic_year_id",
    type: "multi-select",
    label: "Academic Year * ",
    className: "select-styles",
    required: true,
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    list: "academic_year_list_ex_sch",
    keyValue: { label: "year_name", value: "year_id" },
   // keyValue: { label: "academic_year", value: "academic_year_id" },
  },
  {
    id: "reservation_status_id",
    type: "multi-select",
    label: "Registration Status *",
    required: true,
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    list: "reservation_status_list",
    keyValue: { label: "registration_status_name", value: "registration_status_id" },
    //keyValue: { label: "reservation_status", value: "reservation_status_id" },
  },
  {
    id: "class_id",
    type: "multi-select-dependency",
    label: "Class *",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    required: true,
    list: "class_course_batch_data",
    keyValue: { label: "class_name", value: "class_id" },
    dependentFields: ["batch_id", "sub_batch_id"],
    dependentFlds: {
      class_course_batch_data: "class_id",
      // batch_list: "batch_id",
    },
  },
  {
    id: "batch_id",
    type: "multi-select-dependency",
    label: "Batch *",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    isDependent: true,
    options: [],
    required: true,
    list: "batch_list_ex_sch",
    dependencyLabel: "Please select Class",
    keyValue: { label: "batch_name", value: "batch_id" },
    fieldKeyLists: {
      // class_course_batch_data: "class_id",
    },
    dependentFields: ["sub_batch_id"],
    dependentFlds: {
     // class_course_batch_data: "class_id",
      batch_list: "batch_id",
      //sub_batch_list: "sub_batch_id",
    },
  },
  {
    id: "sub_batch_id",
    type: "multi-select-dependency",
    label: "Sub Batch *",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    isDependent: true,
    required: true,
    options: [],
    list: "sub_batch_list_ex_sch",
    dependencyLabel: "Please select Class & Batch",
    keyValue: { label: "sub_batch_name", value: "sub_batch_id" },
    fieldKeyLists: {
      // class_course_batch_data: "class_id",
      // batch_list: "batch_id",
    },
    dependentFlds: {
      // class_course_batch_data: "class_id",
      // batch_list: "batch_id",
      sub_batch_list: "sub_batch_id",
    },
  },
  {
    id: "state_id",
    type: "multi-select-dependency",
    label: "State",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    list: "state_list_ex_sch",
    keyValue: { label: "state_name", value: "state_id" },
    dependentFields: ["college_id"],
    dependentFlds: {
      state_list: "state_id",
    },
  },
  {
    id: "college_id",
    type: "multi-select-dependency",
    label: "College",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    isDependent: true,
    options: [],
    list: "college_list_ex_sch",
    dependencyLabel: "Please select State",
    keyValue: { label: "college_name", value: "college_id" },
    fieldKeyLists: {
      //state_list: "state_id",
    },
  },
  {
    id: "board_id",
    type: "multi-select-dependency",
    label: "Board",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    list: "board_list",
    keyValue: { label: "board_name", value: "board_id" },
  },
  {
    id: "ntse_exam_object_id",
    type: "normal-select",
    label: "NTSE Exam",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    list: "ntse_exam_list",
    onlyApiCall: true,
    requestList: async (payload) => {
      return {};
    },
    endpoint:endpointsMd.GET_NTSE_EXAM_LIST,
    keyValue: { label: "ntse_exam_name", value: "ntse_exam_id" },
    options: [],
    //keyValue: { label: "name", value: "object_id" },
  },
  {
    id: "cnaps_level_list",
    type: "multi-select",
    label: "CNAPS Level",
    className: "select-styles",
    list: "cnaps_level_list",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    keyValue: { label: "cnaps_level_name", value: "cnaps_level_id" },
    //keyValue: { label: "name", value: "object_id" },
  },
  {
    id: "delivery_type_object_id",
    type: "normal-select",
    label: "Delivery Type",
    className: "select-styles",
    list: "delivery_type_list",
    onlyApiCall: true,
    requestList: async (payload) => {
      return {};
    },
    endpoint:endpointsMd.GET_DELIVERY_TYPE_LIST,
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    keyValue: { label: "delivery_type_name", value: "delivery_type_id" },
   // keyValue: { label: "name", value: "object_id" },
  },
];

  export function getSelectedStates(stateList, selectedStateIds) {
    return stateList?.filter((state) =>
      selectedStateIds?.includes(state?.state_id)
    );
  }

 export function getSelectedYear(yearList, selectedYearIds) {
    return yearList?.filter((year) => selectedYearIds?.includes(year?.year_id));
  }